import { useSeo } from "@/lib/useSeo";

export default function MediaKit() {
useSeo({
title: "Kit média & presse | Dorothée Lancelot",
description: "Kit média de Dorothée Lancelot : audience, parcours, conférences, univers éditorial, Les Chroniques de l’Étrange et opportunités de collaboration.",
  
});

return (
<div className="dl-container py-16 max-w-4xl">
<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
<div>
<div className="dl-eyebrow">Presse & partenariats</div>
<h1 className="serif text-4xl text-[#F3E9D2] mt-2">
Kit média Dorothée Lancelot
</h1>
</div>

<a
href="/Kit_media_Dorothee_Lancelot_2026.pdf"
download
className="dl-btn dl-btn-solid"
>
Télécharger le kit média
</a>
</div>

<div className="border border-[rgba(198,167,106,0.30)] bg-[#0B1020] p-3 sm:p-5">
<img
src="/kit-media-dorothee-lancelot-2026.png"
alt="Kit média Dorothée Lancelot 2026"
className="w-full h-auto"
/>
</div>

<p className="text-center text-[#F3E9D2]/60 text-sm mt-6">
Médias • Édition • Conférences • Partenariats • Création de contenu
</p>
</div>
);
}
